enum ScheduleDay {
    lunes = "lunes",
    martes = "martes",
    miercoles = "miercoles",
    jueves = "jueves",
    viernes = "viernes",
    sabado = "sabado",
    domingo = "domingo",
}

export default class ScheduleEntity {
    id: string;
    day: ScheduleDay;
    openTime: string;
    closeTime: string;
    // neededStaff: number;

    constructor(
        _: {
            id: string,
            day: ScheduleDay,
            openTime: string,
            closeTime: string,
            // neededStaff: number
        }
    ) {
        this.id = _.id;
        this.day = _.day;
        this.openTime = _.openTime;
        this.closeTime = _.closeTime;
        // this.neededStaff = _.neededStaff;
    }
}

export { ScheduleDay };